import { settingsConstants } from '../_constants';
import { settingsService } from '../_services';
import { alertActions } from './';

export const settingsActions = {
  listCompany,
  createCompany,
  updateCompany
}

function listCompany(companyUuid) {
  return dispatch => {
    dispatch(request('LIST_COMPANY_REQUEST', {companyUuid}));

    return settingsService.listCompany(companyUuid)
      .then(data => {
        dispatch(alertActions.success(data));
        return dispatch(success('LIST_COMPANY_SUCCESS', data));
      }, error => {
        dispatch(alertActions.failure(error));
        return dispatch(failure('LIST_COMPANY_FAILURE', error));
      })
  }
}

function createCompany(companyUuid, obj) {
  return dispatch => {
    dispatch(request('CREATE_COMPANY_REQUEST', {companyUuid, obj}));

    return settingsService.createCompany(companyUuid, obj)
      .then(data => {
        dispatch(alertActions.success(data));
        return dispatch(success('CREATE_COMPANY_SUCCESS', data));
      }, error => {
        dispatch(alertActions.failure(error));
        return dispatch(failure('CREATE_COMPANY_FAILURE', error));
      })
  }
}

function updateCompany(companyUuid, obj) {
  return dispatch => {
    dispatch(request('UPDATE_COMPANY_REQUEST', {companyUuid, obj}));

    return settingsService.updateCompany(companyUuid, obj)
      .then(data => {
        dispatch(alertActions.success(data));
        return dispatch(success('UPDATE_COMPANY_SUCCESS', data));
      }, error => {
        dispatch(alertActions.failure(error));
        return dispatch(failure('UPDATE_COMPANY_FAILURE', error));
      })
  }
}

const request = (constant, data) => {
  return { type: settingsConstants[constant], data }
}

const success = (constant, data) => {
  return { type: settingsConstants[constant], data }
}

const failure = (constant, error) => {
  return { type: settingsConstants[constant], error }
}